import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 15 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 19\" id=\"icon-phone\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.325 1.192c.73-.664 1.926-1.713 2.39-.89l2.43 4.313C5.785 5.64 4.505 6.12 3.566 6.41c.472 2.708 3.317 6.871 5.637 8.252.587-.805 1.465-1.873 2.529-1.87l3.122 3.816c.597.728-.775 1.521-1.633 1.997C6.86 21.66-3.73 6.159 1.325 1.192Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol